import { amplifyClient, getEndpointV2 } from 'api';
import { createApiSlice } from 'helpers/createApiSlice';
import { call } from 'redux-saga/effects';
import { UserSignParam } from 'types';

type Data = Array<UserSignParam>;

/**
 * No used now day
 */
export const signParamFetch = createApiSlice<Data>({
  name: 'signParamFetch',
  *tryGenerator() {
    const { data } = yield call(amplifyClient, {
      method: 'get',
      url: getEndpointV2({ path: '/auth/signParam' }),
    });

    return data;
  },
});
